import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function PostWebinar() {
  const [id, setId] = useState('');
  const [nomorHp, setNomorHp] = useState('628');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id && nomorHp) {
      navigate(`/webinar-payments/${id}/${nomorHp}`);
    } else {
      alert('Silakan isi ID dan Nomor HP.');
    }
  };

  return (
    <div className="container mt-4">
      <h2>Form Benefit Webinar</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="id" className="form-label">ID Peserta:</label>
          <input
            type="text"
            className="form-control"
            id="id"
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="Masukkan ID Peserta"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="nomorHp" className="form-label">Nomor HP:</label>
          <input
            type="text"
            className="form-control"
            id="nomorHp"
            value={nomorHp}
            onChange={(e) => setNomorHp(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Cari Peserta</button>
      </form>
    </div>
  );
}

export default PostWebinar;
